import React from 'react'
import { cx } from '@/lib/utils'
import styles from './CardBody.module.scss'

type Padding = 'sm' | 'md' | 'lg'

interface CardBodyProps {
  children: React.ReactNode
  padding?: Padding
}

const paddingMap: Record<Padding, string> = {
  sm: styles.padSm, md: styles.padMd, lg: styles.padLg,
}

export const CardBody: React.FC<CardBodyProps> = ({ children, padding = 'md' }) => (
  <div className={cx(styles.body, paddingMap[padding])}>
    {children}
  </div>
)
